import React, { useEffect } from 'react';

export default function InteractiveVenueExplorer() {
  useEffect(() => {
    const dwtcexplorerCss = document.createElement('link');
    dwtcexplorerCss.href = 'https://d2q0dg49mzo6xk.cloudfront.net/webplayer/dwtc/dwtcexplorer.css';
    dwtcexplorerCss.rel = 'stylesheet';
    document.head.appendChild(dwtcexplorerCss);

    dwtcexplorerCss.onload = () => {
      const dwtcexplorerScript = document.createElement('script');
      dwtcexplorerScript.src = 'https://d2q0dg49mzo6xk.cloudfront.net/webplayer/dwtc/dwtcexplorer.js';
      dwtcexplorerScript.async = true;
      document.body.appendChild(dwtcexplorerScript);

      dwtcexplorerScript.onload = () => {
        if (window.DWTCExplorer) {
          window.DWTCExplorer({ container: "dwtc_map" });
        } else {
          console.error('DWTCExplorer function not found');
        }
      };
    };

    return () => {
      // Cleanup to remove the added resources when the component unmounts
      document.head.removeChild(dwtcexplorerCss);
      const script = document.querySelector(`script[src='https://d2q0dg49mzo6xk.cloudfront.net/webplayer/dwtc/dwtcexplorer.js']`);
      if (script) {
        document.body.removeChild(script);
      }
    };
  }, []);

  return <div id="dwtc_map" />;
}
